<script>
	export let layout;
	export let hover = null;
</script>

{#each layout.bars as b}
	<path d={b.d} class="bar" class:dim={hover && hover.kind === "x" && hover.index !== b.cat} style="--c:{b.color}" />
{/each}

<style>
	.bar {
		fill: var(--c);
	}

	.bar.dim {
		opacity: 0.55;
	}

	@media (prefers-reduced-motion: no-preference) {
		.bar {
			transition: opacity 0.12s ease-out;
		}
	}
</style>
